import RevisionHistoryAPI from '@/api/RevisionHistoryAPI'

const module = 'REVISION_HISTORY_'

export const GET_REVISION_HISTORY = module + 'SET_REVISION_HISTORY'
export const FORWARD_REVISION_HISTORY = module + 'FORWARD_REVISION_HISTORY'
export const SET_BRANCHES = module + 'SET_BRANCHES'
export const SET_CURRENT_BRANCH = module + 'SET_CURRENT_BRANCH'
export const SET_CURRENT_MOVE = module + 'SET_CURRENT_MOVE'
export const FORWARD_CURRENT_BRANCH = module + 'FORWARD_CURRENT_BRANCH'
export const CREATE_NEW_BRANCH = module + 'CREATE_NEW_BRANCH'
export const SET_TARGET_BRANCH = module + 'SET_TARGET_BRANCH'
export const SET_CURRENT_BRANCH_AUDIENCE = module + 'SET_CURRENT_BRANCH_AUDIENCE'
export const ADD_BRANCH = module + 'ADD_BRANCH'
export const DELETE_BRANCH = module + 'DELETE_BRANCH'
export const SET_PRIMARY_BRANCH = module + 'SET_PRIMARY_BRANCH'
export const SET_MISSING_BRANCH = module + 'SET_MISSING_BRANCH'

const actions = {
  [DELETE_BRANCH]: (context, {id}) => {
    RevisionHistoryAPI.deleteBranch({branchId: id}).then(data => {
      context.commit(DELETE_BRANCH, id)
    })
  },
  /**
   * This is going to call the API to get the revision history
   */
  [GET_REVISION_HISTORY]: (context, {targetId}) => {
    return RevisionHistoryAPI.getRevisionHistoryForTarget({target_id: targetId})
    .then(data => {
      context.commit(SET_BRANCHES, data.branches)
    })
  },
  [SET_MISSING_BRANCH]: (context, {id, display_name}) => {
    return RevisionHistoryAPI.createMissingBranch({id, display_name})
    .then(data => {
      context.commit(SET_BRANCHES, [{
        id: data.branch_id,
        label: display_name,
        histories: []
      }])
      context.dispatch(SET_TARGET_BRANCH, {name: display_name})
      context.dispatch(SET_PRIMARY_BRANCH, {name: display_name})
    })
  },
  [SET_TARGET_BRANCH]: (context, {name}) => {
    // TODO when I created a new Target, it did not create a Revision Branch for it
    // TODO it seems like this is happening
    // TODO add the posted data to the API, and choose the one that was created last...
    // TODO we will update the backend to accept the Last or Default Branch as well, for each user
    // TODO we need to update this find function
    const currentBranch = context.state.branches.find(b => b.label === name)
    if (currentBranch) {
      context.dispatch(SET_CURRENT_BRANCH, currentBranch)
    }
  },
  [SET_PRIMARY_BRANCH]: (context, {name}) => {
    const primaryBranch = context.state.branches.find(b => b.label === name)
    context.commit(SET_PRIMARY_BRANCH, primaryBranch)
  },
  [SET_CURRENT_BRANCH]: (context, branch) => {
    context.commit(SET_CURRENT_BRANCH, branch)
    if (branch.histories.length > 0) {
      const currentRevision = branch.histories[0]
      context.commit(SET_CURRENT_MOVE, currentRevision)
      return currentRevision
    }
    // TODO need to set a default current move or something
  },
  [CREATE_NEW_BRANCH]: (context, {label, audience, targetId}) => {
    const branchOff = {
      label,
      branch_off_id: context.state.currentBranch.id,
      duplicate_up_to_move: context.state.currentMove.move,
      audience,
      target_id: targetId
    }
    const newBranch = {
      label,
      audience
    }
    RevisionHistoryAPI.branchOffRevisionBranch(branchOff)
    .then(data => {
      newBranch.id = data.created_branch_id
      newBranch.histories = data.revision_history_of_branch
      context.commit(ADD_BRANCH, newBranch)
      context.dispatch(SET_CURRENT_BRANCH, newBranch)
    })
  },
  /**
   * This is going to forward the current branch up on the Revision History
   */
  [FORWARD_REVISION_HISTORY]: (context, targetInfo) => {
    const nextMove = context.state.currentMove ? context.state.currentMove.move + 1 : 1
    const dataToSend = {
      id: context.state.currentBranch.id,
      move: nextMove,
      target_definition: targetInfo.targetDefinition,
      label: targetInfo.label,
      target_data: targetInfo.targetData,
      audience: parseInt(targetInfo.audience),
      targetId: context.getters.targetInfo.id
    }
    const revision = {
      ...dataToSend,
      id: null
    }
    // TODO should we even forward the revision, maybe we should wait until the user makes a save
    RevisionHistoryAPI.forwardRevision(dataToSend).then(resp => {
      revision.id = resp.revision_id
      context.dispatch(FORWARD_CURRENT_BRANCH, revision)
    })
  },
  [FORWARD_CURRENT_BRANCH]: (context, revisionHistory) => {
    context.commit(FORWARD_CURRENT_BRANCH, revisionHistory)
  },
  [SET_CURRENT_MOVE]: (context, revision) => {
    context.commit(SET_CURRENT_MOVE, revision)
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/app/appLogic/revisionHistory/store/actions.js